<template>
  <el-dropdown-item
      v-bind="$attrs">
    <div :class="['dropdown-item', font14 ? 'font14' : 'font12']"
         @click="$emit('click')">
      <slot></slot>
    </div>
  </el-dropdown-item>
</template>

<script>
  export default {
    name: "gj-dropdown-item",
    props: {
      font14: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style scoped>
  .dropdown-item {
    margin: 0 -20px;
    padding: 0 20px;
  }
  .font12 {
    font-size: 12px;
    line-height: 33px;
  }
  .font14 {
    font-size: 14px;
    line-height: 36px;
  }
</style>
